import { defaultHTTPRequests } from './http-request-service';
import axios from "axios";

export const paths = {
    POLLING_IMPORT:'/pml/uplfile/:uuid/rows?projection=count&groupBy=outcome',
    REFRESH_TOKEN: '/pml/refresh-token'
}

/**
 * POLLING IMPORT - per ricevere la count raggruppata per status
 * @param {string} uuid : uuid materialsheet
 */
export const POLLING_IMPORT = (uuid) => {
    return defaultHTTPRequests('GET',paths.POLLING_IMPORT.replace(/:uuid/gi,uuid), null);
}


export const REFRESH_TOKEN = (authToken) => {

    /*var xhr = new XMLHttpRequest()
   
    // open the request with the verb and the url
    xhr.open('GET', paths.REFRESH_TOKEN, false);
    xhr.setRequestHeader("Authorization", authToken);
    // send the request
    xhr.send();

    return xhr;*/

    
    axios.defaults.headers['Authorization'] = authToken;
    /* time in millisecondi 5000 = 5secondi*/
    return axios.get(paths.REFRESH_TOKEN, {timeout: 5000});

}

